import { render, staticRenderFns } from "./registerLocation.vue?vue&type=template&id=590914a6&scoped=true&"
import script from "./registerLocation.vue?vue&type=script&lang=js&"
export * from "./registerLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590914a6",
  null
  
)

export default component.exports